<script setup>
import { reactive, computed } from 'vue';
import { useStore } from 'vuex';
import apiManager from '@/api';
import BigModal from './BigModal.vue';

defineProps({
  id: String, // eventId?
  showQuestion: Boolean,
});

const emit = defineEmits(['close', 'registered']);

const store = useStore();

const solutions = computed(() => store.state.solutions.solutions);

const fleetSizes = computed(() => store.state.fleetSizes.fleetSizes);

const successTimeout = 10000;

const success = reactive({
  value: false,
  message: '',
  timeout: successTimeout,
});

const error = reactive({
  value: false,
  message: '',
  timeout: successTimeout,
});

const register = async (inputs) => {
  try {
    await apiManager.events.register(inputs);
    success.message = 'Congratulations! You are now registered for this event.';
    success.value = true;
  } catch (e) {
    if (e.response.status === 409) {
      success.message = 'Great News! You are already registered for this event.';
      success.value = true;
    } else {
      error.message = 'We are very sorry. Something went wrong, try again later.';
      error.value = true;
    }
  } finally {
    setTimeout(() => {
      emit('registered');
    }, successTimeout);
  }
};

</script>
<template>
  <big-modal
    @validated="register"
    @close="() => emit('close')"
    title="Register"
    subTitle="
      Complete the form below to learn how Ford Pro™
      can be a productivity accelerator for your business.
    "
    :success="success"
    :error="error"
    :id="id"
    :fleetSizes="fleetSizes"
    :solutions="solutions"
    interested-text="I would like Ford Motor Company,
      its affiliates, authorized dealers, and
      business partners to contact me about the
      information I've indicated I'm interested in."
    outside-text="I agree that Ford Motor Company, its affiliates, authorized dealers,
      and business partners can contact me about products, services,
      news, offers, and incentives. I understand that unsubscribing
      from communications from Ford Motor Company will not affect communications
      I receive from others, who may provide their own methods for unsubscribing."
    :showQuestion="showQuestion" />
</template>
